import PageFooter from "./PageFooter";

export default PageFooter;
